import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leave-rule',
  templateUrl: './leave-rule.component.html',
  styleUrls: ['./leave-rule.component.css']
})
export class LeaveRuleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
